module.exports = __webpack_public_path__ + "img/arrow-plus-white.514bed91.svg";